import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {County, instytutionsType} from './institutions.enum';
import {Observable} from 'rxjs';
import {debounceTime, map, startWith, switchMap, tap} from 'rxjs/operators';
import { finalize } from 'rxjs/internal/operators';
import {InsititutionsService} from './insititutions.service';

@Component({
  selector: 'app-institutions-filters',
  templateUrl: './institutions-filters.component.html',
  styleUrls: ['./institutions-filters.component.scss']
})

export class InstitutionsFiltersComponent implements OnInit {
  @Output() onSearch: EventEmitter<FormGroup> = new EventEmitter();
  @Input() mapCitiesNames;
  isLoading: boolean;
  public libsCounty: string[] = County;
  public institutionsTypes: string[] = instytutionsType;
  control = new FormControl();
  filteredCity: Observable<string[]>;

  public filtersFormGroup = new FormGroup({
    institutionName: new FormControl(),
    type: new FormControl(''),
    city: new FormControl(),
    region: new FormControl('')
  });
  constructor(private _institutionsService: InsititutionsService) {
  }

  ngOnInit() {
    this.filtersFormGroup.get('city')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap(value => this._institutionsService.getCities(value)
          .pipe(
            finalize(() => this.isLoading = false),
          )
        )
      ).subscribe(users => this.filteredCity = users);
  }


  search(): void {
    this.onSearch.emit(this.filtersFormGroup);
  }

}
